export default "__VITE_PUBLIC_ASSET__49debfca__"